// extracted by mini-css-extract-plugin
module.exports = {"InvalidInput":"Auth_InvalidInput__QTFxn"};